var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteLogoActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Square",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1347.13 1347.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#F5A623;stroke-miterlimit:10;stroke-width:45px;}.cls-2{fill:#F5A623;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Josh&amp;apos;s Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.5,
    y: 22.5,
    width: 1302.13,
    height: 1302.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.54,498.35a109,109,0,0,1-42.63-36.5l28.42-33.32q28.41,40.68,71.54,40.67,28.91,0,43.85-17.64t14.95-51.94V207h-124V164.42H362.18V397.17q0,56.85-27.19,85.5t-80.12,28.67A128.33,128.33,0,0,1,197.54,498.35Z",
    transform: "translate(-76.43 -78.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M641.46,499.33q-36-12-56.6-31.12L603,430q19.59,17.64,50.22,28.67a184.52,184.52,0,0,0,63,11q42.63,0,63.7-14.46T801,416.77q0-17.64-11.52-28.67A77,77,0,0,0,761,371.2q-16.9-5.88-47.77-13.23-38.71-9.3-62.48-18.62a103.16,103.16,0,0,1-40.67-28.67Q593.2,291.33,593.2,258.5q0-27.44,14.46-49.49t43.85-35.28q29.4-13.23,73-13.23a231.27,231.27,0,0,1,59.78,7.84q29.4,7.84,50.47,22.54l-16.17,39.2a177.78,177.78,0,0,0-46.06-20.83,172.12,172.12,0,0,0-48-7.1q-41.65,0-62.48,15.19t-20.83,39.2q0,17.64,11.76,28.67t29.15,17.15q17.39,6.13,47.29,13,38.7,9.31,62.23,18.62a104.78,104.78,0,0,1,40.42,28.42Q849,381.49,849,413.83a87.57,87.57,0,0,1-14.7,49.24q-14.7,22.3-44.59,35.28t-73.5,13A234.59,234.59,0,0,1,641.46,499.33Z",
    transform: "translate(-76.43 -78.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1295,164.42v343h-49V354.54H1049V507.42h-49v-343h49V311.91h197V164.42h49Z",
    transform: "translate(-76.43 -78.58)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.77,571.42h49V871.79H445.48v42.63H210.77v-343Z",
    transform: "translate(-76.43 -78.58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M865.15,871.79v42.63H616.23v-343H858.29V614H665.23V719.4h172V761h-172V871.79H865.15Z",
    transform: "translate(-76.43 -78.58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1282.18,871.79v42.63H1033.26v-343h242.06V614H1082.26V719.4h172V761h-172V871.79h199.92Z",
    transform: "translate(-76.43 -78.58)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.77,977.87H355.32q54.39,0,96.53,21.56t65.42,60.52q23.27,39,23.28,89.42t-23.28,89.42q-23.28,39-65.42,60.51t-96.53,21.56H210.77v-343Zm141.61,300.37q41.64,0,73.25-16.17t48.75-45.33q17.15-29.15,17.15-67.37T474.39,1082q-17.16-29.15-48.75-45.33t-73.25-16.17H259.77v257.74h92.61Z",
    transform: "translate(-76.43 -78.58)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M865.15,1278.24v42.63H616.23v-343H858.29v42.63H665.23v105.35h172v41.65h-172v110.74H865.15Z",
    transform: "translate(-76.43 -78.58)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1331.18,978.32l-150.43,343h-48.51l-150.92-343h52.92l123.48,281.75,124.46-281.75h49Z",
    transform: "translate(-76.43 -78.58)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLogoActive);
export default __webpack_public_path__ + "static/media/site-logo-active.8a86717331f43837fde8e3232f05909b.svg";
export { ForwardRef as ReactComponent };